export const DocumentTypeVals = {
    Quality: 5,
    // Реестр документов
    Registry: 6,
    InputControlJournal: 11,
    License: 15,
    // Приказ о назначении ответственного лица
    ResponsiblePersonOrder: 8
};
